import { HasValue } from "../services/funcoes";

export default function formatarQuantidade(valor, casasDecimais = 0) {
    if (!HasValue(valor)) {
        valor = 0;
    }

    // Convertendo valores com vírgula corretamente
    let numero = typeof valor === "string" ? parseFloat(valor.replace(',', '.')) : parseFloat(valor);

    // Se o número for NaN após a conversão, define como 0
    if (isNaN(numero)) {
        numero = 0;
    }

    return numero.toFixed(casasDecimais).replace('.', ',');
}
